package com.raouf.mehrguard.web.i18n

internal val RussianStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Kotlin Multiplatform Детектор QRishing",
    WebStringKey.MenuMain to "Главное меню",
    WebStringKey.MenuSecurity to "Безопасность",
    WebStringKey.MenuSystem to "Система",
    WebStringKey.NavDashboard to "Панель",
    WebStringKey.NavScanMonitor to "Монитор сканирования",
    WebStringKey.NavScanHistory to "История сканирований",
    WebStringKey.NavTrustCentre to "Центр доверия",
    WebStringKey.NavReports to "Отчёты",
    WebStringKey.NavTraining to "Обучение",
    WebStringKey.NavSettings to "Настройки",
    WebStringKey.QuickActions to "Быстрые действия",

    // Hero Section
    WebStringKey.HeroTagline to "Безопасно. Офлайн.",
    WebStringKey.HeroTagline2 to "Объяснимая защита.",
    WebStringKey.HeroDescription to "Mehr Guard анализирует потенциальные угрозы непосредственно на вашем оборудовании. Получите защиту с нулевой задержкой.",

    // Dashboard
    WebStringKey.StartScan to "Начать новое сканирование",
    WebStringKey.ImportImage to "Импорт изображения",
    WebStringKey.ScanQrCode to "Сканировать QR-код",
    WebStringKey.SystemHealth to "Состояние системы",
    WebStringKey.ThreatDatabase to "База данных угроз",
    WebStringKey.Current to "Текущий",
    WebStringKey.Active to "Активен",
    WebStringKey.Threats to "Угрозы",
    WebStringKey.SafeScans to "Безопасные сканирования",
    WebStringKey.EngineActive to "Движок активен",
    WebStringKey.EnterpriseProtection to "Корпоративная защита активна",
    WebStringKey.SystemOptimal to "Система оптимальна",
    WebStringKey.EngineStatus to "Движок v2.4 • Обновлено 2ч назад",
    WebStringKey.ThreatsBlocked to "Угроз заблокировано",
    WebStringKey.AllSystemsOperational to "Все системы работают",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Обзор",
    WebStringKey.SectionSecurity to "Безопасность",
    WebStringKey.SectionTraining to "Обучение",
    WebStringKey.SectionReports to "Отчёты",
    WebStringKey.OfflineReady to "Готов к офлайн-работе",
    WebStringKey.OfflineDescription to "Локальная база данных v2.4.1 активна. Никакие данные не покидают это устройство.",

    // Trust Centre
    WebStringKey.TrustCentreTitle to "Центр доверия",
    WebStringKey.OfflineGuarantee to "Строгая офлайн-гарантия",
    WebStringKey.OfflineGuaranteeDesc to "Анализ Mehr Guard выполняется полностью на Neural Engine вашего устройства. Данные URL никогда не покидают ваш телефон.",
    WebStringKey.ThreatSensitivity to "Чувствительность к угрозам",
    WebStringKey.ResetConfirm to "Это сбросит все настройки Центра доверия к значениям по умолчанию.",

    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Монитор угроз",
    WebStringKey.ThreatMonitorDesc to "Просмотр угроз в реальном времени и запуск аудита безопасности",
    WebStringKey.TrustCentreDesc to "Настройки конфиденциальности и чувствительности к угрозам",
    WebStringKey.ExportReport to "Экспорт отчёта",
    WebStringKey.ExportReportDesc to "Создать отчёт о безопасности в формате PDF или JSON",

    // Dashboard Content
    WebStringKey.Analyze to "Анализировать",
    WebStringKey.HeuristicEngine to "Эвристический движок",
    WebStringKey.HighPerformanceEngine to "Высокопроизводительный движок",
    WebStringKey.RecentScans to "Недавние сканирования",
    WebStringKey.ViewFullHistory to "Просмотреть полную историю",
    WebStringKey.Status to "Статус",
    WebStringKey.Source to "Источник",
    WebStringKey.Details to "Детали",
    WebStringKey.Time to "Время",
    WebStringKey.Version to "Версия",
    WebStringKey.LastUpdate to "Последнее обновление",
    WebStringKey.Signatures to "Сигнатуры",
    WebStringKey.CheckForUpdates to "Проверить обновления",
    WebStringKey.FeatureOfflineTitle to "Архитектура Offline-First",
    WebStringKey.FeatureOfflineDesc to "Полный анализ выполняется локально. Ваша камера и отсканированные данные никогда не попадают на внешний сервер, обеспечивая абсолютную конфиденциальность.",
    WebStringKey.FeatureExplainableTitle to "Объяснимая безопасность",
    WebStringKey.FeatureExplainableDesc to "Не просто получите \"Блок\". Мы предоставляем подробный эвристический анализ параметров URL, перенаправлений и JavaScript-нагрузок.",
    WebStringKey.FeaturePerformanceDesc to "Оптимизирован для настольных сред. Сканирования обрабатываются менее чем за 5мс с использованием нативных бинарных файлов Kotlin Multiplatform.",
    WebStringKey.TrainingCentre to "Учебный центр",
    WebStringKey.LearnHomograph to "Узнайте, как идентифицировать продвинутые омографические атаки QR.",
    WebStringKey.BeatTheBotAction to "Победи бота →",
    WebStringKey.NoScansYet to "Пока нет сканирований. Начните новое сканирование, чтобы увидеть результаты здесь.",
    WebStringKey.VerdictSafe to "БЕЗОПАСНО",
    WebStringKey.VerdictPhish to "ФИШИНГ",
    WebStringKey.VerdictWarn to "ВНИМАНИЕ",
    WebStringKey.ScoreLabel to "Оценка:",

    // Scanner
    WebStringKey.ActiveScanner to "Активный сканер",
    WebStringKey.OfflineMode to "Офлайн-режим",
    WebStringKey.LiveFeedDisconnected to "ЖИВАЯ ЛЕНТА ОТКЛЮЧЕНА",
    WebStringKey.CameraAccessRequired to "Требуется доступ к камере",
    WebStringKey.CameraAccessDescription to "Перетащите изображение QR-кода сюда или включите доступ к камере, чтобы начать сканирование.",
    WebStringKey.EnableCamera to "Включить камеру",
    WebStringKey.Scanning to "Сканирование...",
    WebStringKey.ScanHint to "Держите неподвижно. Анализ офлайн за <5мс.",
    WebStringKey.Torch to "Фонарик",
    WebStringKey.Gallery to "Галерея",
    WebStringKey.PasteUrl to "Вставить URL",
    WebStringKey.PasteUrlTitle to "Вставьте URL для анализа",
    WebStringKey.AnalyzeUrl to "Анализировать URL",
    WebStringKey.SystemStatus to "Статус системы",
    WebStringKey.PhishingEngine to "Движок фишинга",
    WebStringKey.Ready to "ГОТОВ",
    WebStringKey.LocalDb to "Локальная БД",
    WebStringKey.Latency to "Задержка",
    WebStringKey.ViewAll to "Просмотреть все",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Главная",
    WebStringKey.BreadcrumbScans to "Сканирования",
    WebStringKey.OfflineProtection to "Офлайн-защита",
    WebStringKey.VerdictHighRisk to "ОБНАРУЖЕН ВЫСОКИЙ РИСК",
    WebStringKey.VerdictDangerous to "Опасно",
    WebStringKey.VerdictDangerousDesc to "Отсканированный QR-код содержит вредоносные индикаторы, связанные с фишингом и сбором учётных данных. Не переходите по целевому URL.",
    WebStringKey.ThreatConfidence to "Уверенность угрозы",
    WebStringKey.FlagPhishing to "Попытка фишинга",
    WebStringKey.FlagObfuscated to "Обфусцированный скрипт",
    WebStringKey.FlagHomograph to "Атака омографов",
    WebStringKey.ClearHistory to "Очистить всё",
    WebStringKey.SectionAttackBreakdown to "Анализ атаки",
    WebStringKey.AttackHomographTitle to "Атака омографов / IDN",
    WebStringKey.AttackHomographDesc to "Обнаружены кириллические символы, имитирующие латинский алфавит.",
    WebStringKey.AttackVisualLabel to "Визуальное отображение",
    WebStringKey.AttackPunycodeLabel to "Фактический Punycode",
    WebStringKey.AttackHomographExplain to "Домен использует кириллический 'а' (U+0430) вместо латинского 'a' (U+0061). Эта техника обычно используется, чтобы обмануть пользователей, заставив их поверить, что они посещают легитимный сервис.",
    WebStringKey.AttackRedirectTitle to "Подозрительная цепочка перенаправлений",
    WebStringKey.AttackRedirectDesc to "Обнаружено 3 перехода с использованием известных сокращателей URL.",
    WebStringKey.RedirectStart to "Сканирование QR-кода",
    WebStringKey.RedirectHop to "Промежуточный переход",
    WebStringKey.RedirectFinal to "Конечный пункт назначения",
    WebStringKey.AttackJsTitle to "Обфусцированный JavaScript",
    WebStringKey.AttackJsDesc to "Обнаружена строка с высокой энтропией в параметрах URL.",
    WebStringKey.SectionActions to "Рекомендуемые действия",
    WebStringKey.ActionBlock to "Заблокировать и сообщить",
    WebStringKey.ActionBlockDesc to "Предотвратить доступ и уведомить администратора",
    WebStringKey.ActionQuarantine to "Карантин в песочнице",
    WebStringKey.ActionQuarantineDesc to "Безопасно открыть для анализа",
    WebStringKey.Expected to "Ожидается: ",
    WebStringKey.Detected to "Обнаружено: ",
    WebStringKey.ExplainableSecurity to "Объяснимая безопасность",
    WebStringKey.UrlBreakdown to "АНАЛИЗ URL",
    WebStringKey.FullUrl to "ПОЛНЫЙ URL",
    WebStringKey.OpenInBrowser to "Открыть в браузере (Рискованно)",
    WebStringKey.OpenWarning to "Открытие этого URL в браузере может подвергнуть вас рискам безопасности.",
    WebStringKey.RestrictedMode to "Ограниченный режим",
    WebStringKey.RestrictedDesc to "Этот URL был помечен как потенциально опасный. Просмотрите анализ ниже перед продолжением.",
    WebStringKey.DangerousWarning to "Этот URL был помечен как потенциально опасный. Его открытие может подвергнуть вас фишингу, вредоносному ПО или другим угрозам безопасности. Вы уверены, что хотите продолжить?",
    WebStringKey.CopyUrl to "Копировать URL",
    WebStringKey.Share to "Поделиться",
    WebStringKey.Dismiss to "Закрыть",
    WebStringKey.ReasonDomainAge to "Возраст домена менее 24 часов.",
    WebStringKey.ReasonSignatures to "Совпадение с 3 сигнатурами в локальной БД фишинга.",
    WebStringKey.ReasonAsn to "Целевой IP находится в ASN высокого риска.",
    WebStringKey.SectionMeta to "Мета сканирования",
    WebStringKey.MetaTime to "Время сканирования",
    WebStringKey.MetaSource to "Источник",
    WebStringKey.MetaEngine to "Движок",
    WebStringKey.MetaOfflineGuaranteeLabel to "Офлайн-гарантия:",
    WebStringKey.MetaOfflineGuaranteeDesc to "Это изображение было проанализировано локально на вашем устройстве. Никакие данные не были отправлены в облако для этого вердикта.",
    
    // Results Page
    WebStringKey.ScanComplete to "Сканирование завершено",
    WebStringKey.Loading to "Загрузка...",
    WebStringKey.AnalyzedOffline to "Проанализировано офлайн за <5мс",
    WebStringKey.NoDataLeaves to "Данные не покидают устройство",
    WebStringKey.ActiveProtection to "Активная защита",
    WebStringKey.ConfidenceScore to "Оценка уверенности",
    WebStringKey.Analyzing to "АНАЛИЗ...",
    WebStringKey.ProcessingResults to "Обработка результатов сканирования...",
    WebStringKey.RiskAssessment to "Оценка рисков",
    WebStringKey.AnalysisTime to "Время анализа",
    WebStringKey.Heuristics to "Эвристика",
    WebStringKey.TopAnalysisFactors to "Основные факторы анализа",
    WebStringKey.Pass to "ПРОЙДЕНО",
    WebStringKey.Info to "ИНФО",
    WebStringKey.Clean to "ЧИСТО",
    WebStringKey.ValidSslCertificate to "Действительный SSL-сертификат",
    WebStringKey.SslCertificateDesc to "Сертификат выдан DigiCert Inc. Аномалий в цепочке доверия нет.",
    WebStringKey.EstablishedDomain to "Устоявшийся домен",
    WebStringKey.EstablishedDomainDesc to "Домен зарегистрирован > 5 лет назад. Низкая вероятность мошенничества.",
    WebStringKey.BlacklistStatus to "Статус чёрного списка",
    WebStringKey.BlacklistStatusDesc to "Не найден в 52 локальных базах угроз.",
    WebStringKey.BackToDashboard to "Вернуться к панели",
    WebStringKey.ShareReport to "Поделиться отчётом",
    WebStringKey.CopyLink to "Копировать ссылку",
    WebStringKey.LinkCopied to "Ссылка скопирована в буфер обмена!",
    
    // Game Page
    WebStringKey.BeatTheBot to "Победи бота",
    WebStringKey.BeatTheBotDesc to "Бросьте вызов нашему офлайн ИИ. Сможете ли вы обнаружить фишинг быстрее?",
    WebStringKey.SessionId to "ID сессии",
    WebStringKey.EndSession to "Завершить сессию",
    WebStringKey.Round to "Раунд",
    WebStringKey.BrowserPreview to "Предпросмотр браузера",
    WebStringKey.MakeDecision to "Примите решение",
    WebStringKey.Phishing to "Фишинг",
    WebStringKey.Legitimate to "Легитимный",
    WebStringKey.LiveHint to "Подсказка в реальном времени",
    WebStringKey.LiveScoreboard to "Табло в реальном времени",
    WebStringKey.VsMode to "РЕЖИМ VS",
    WebStringKey.You to "Вы",
    WebStringKey.Points to "очки",
    WebStringKey.Streak to "Серия",
    WebStringKey.Accuracy to "Точность",
    WebStringKey.MehrGuardBot to "Бот Mehr Guard",
    WebStringKey.Confidence to "Уверенность",
    WebStringKey.RoundAnalysis to "Анализ раунда",
    WebStringKey.Analysis to "Анализ",
    WebStringKey.CorrectDecision to "Верное решение!",
    WebStringKey.IdentifiedSafe to "Вы правильно определили безопасный URL.",
    WebStringKey.AiNeuralAnalysis to "Нейронный анализ ИИ",
    WebStringKey.WhyBotFlagged to "Почему бот отметил",
    WebStringKey.EducationalNote to "Образовательная заметка",
    WebStringKey.Correct to "Верно!",
    WebStringKey.SpottedPhishing to "Вы правильно обнаружили фишинговый URL.",
    WebStringKey.Response to "Ответ",
    WebStringKey.NextRound to "Следующий раунд",
    WebStringKey.GameOver to "Игра окончена!",
    WebStringKey.FinalResults to "Итоговые результаты",
    WebStringKey.YourScore to "Ваш счёт",
    WebStringKey.BotScore to "Счёт бота",
    WebStringKey.BestStreak to "Лучшая серия",
    WebStringKey.PlayAgain to "Играть снова",
    WebStringKey.ReturnToDashboard to "Вернуться к панели",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "Экспорт отчёта о безопасности",
    WebStringKey.GenerateReport to "Создавайте полные отчёты о безопасности из истории сканирований.",
    WebStringKey.ReportFormat to "Формат отчёта",
    WebStringKey.HumanReadable to "Читаемый отчёт",
    WebStringKey.HumanReadableDesc to "PDF с визуальным анализом и резюме",
    WebStringKey.MachineReadable to "Машиночитаемые данные",
    WebStringKey.MachineReadableDesc to "Формат JSON для интеграции SIEM",
    WebStringKey.DateRange to "Период",
    WebStringKey.Last7Days to "Последние 7 дней",
    WebStringKey.Last30Days to "Последние 30 дней",
    WebStringKey.Last90Days to "Последние 90 дней",
    WebStringKey.AllTime to "Всё время",
    WebStringKey.CustomRange to "Пользовательский период",
    WebStringKey.ReportSections to "Разделы отчёта",
    WebStringKey.ExecutiveSummary to "Резюме",
    WebStringKey.ThreatBreakdown to "Анализ угроз",
    WebStringKey.ScanTimeline to "Хронология сканирований",
    WebStringKey.SafeUrlList to "Список безопасных URL",
    WebStringKey.GenerateExport to "Экспортировать отчёт",
    
    // Toast / Notifications
    WebStringKey.Success to "Успех!",
    WebStringKey.Error to "Ошибка",
    WebStringKey.Warning to "Предупреждение",
    WebStringKey.CopiedToClipboard to "Скопировано в буфер обмена",
    
    // General Actions
    WebStringKey.Cancel to "Отмена",
    WebStringKey.Confirm to "Подтвердить",
    WebStringKey.Save to "Сохранить",
    WebStringKey.Delete to "Удалить",
    WebStringKey.Edit to "Редактировать",
    WebStringKey.Close to "Закрыть",
    WebStringKey.Back to "Назад",
    WebStringKey.Next to "Далее",
    WebStringKey.Previous to "Назад",
    WebStringKey.Submit to "Отправить",
    WebStringKey.Reset to "Сбросить",
    WebStringKey.Clear to "Очистить",
    WebStringKey.Search to "Поиск",
    WebStringKey.Filter to "Фильтр",
    WebStringKey.Sort to "Сортировка",
    
    // Accessibility
    WebStringKey.ToggleMenu to "Переключить меню",
    WebStringKey.ToggleTheme to "Переключить тему",
    WebStringKey.Notifications to "Уведомления",
    WebStringKey.Help to "Помощь",
    WebStringKey.Profile to "Профиль",
    WebStringKey.ToggleLightDarkMode to "Переключить светлый/тёмный режим",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "Вставьте URL для анализа (напр.: https://example.com)",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "Сканирование",
    WebStringKey.Result to "Результат",
    WebStringKey.ReportGeneration to "Генерация отчёта",
    WebStringKey.ReportGenerationDesc to "Настройте форматы и скачайте анализ угроз.",
    WebStringKey.OfflineSecurity to "Офлайн-безопасность",
    WebStringKey.OfflineSecurityDesc to "Ваши данные никогда не покидают это устройство. Вся обработка локальна.",
    WebStringKey.ChooseFormat to "Выбрать формат",
    WebStringKey.PdfFormatDesc to "Формат PDF. Идеально для обмена.",
    WebStringKey.JsonFormatDesc to "Формат JSON. Идеально для интеграции SIEM.",
    WebStringKey.Copy to "Копировать",
    WebStringKey.LivePreview to "Предпросмотр в реальном времени",
    WebStringKey.ReadOnly to "Только чтение",
    WebStringKey.ThreatAnalysisReport to "Отчёт об анализе угроз",
    WebStringKey.Verdict to "Вердикт",
    WebStringKey.RiskScore to "Оценка риска",
    WebStringKey.TargetUrl to "Целевой URL",
    WebStringKey.AnalysisSummaryLabel to "Сводка анализа",
    WebStringKey.TechnicalIndicators to "Технические индикаторы",
    WebStringKey.ExportInfoNote to "Экспорт включает все выявленные векторы угроз и анализ payload.",
    
    // Trust Centre Page
    WebStringKey.AllowList to "Список разрешённых",
    WebStringKey.BlockList to "Список заблокированных",
    WebStringKey.AddDomain to "Добавить домен",
    WebStringKey.RemoveDomain to "Удалить домен",
    WebStringKey.TrustedDomains to "Доверенные домены",
    WebStringKey.BlockedDomains to "Заблокированные домены",
    WebStringKey.DomainPlaceholder to "Введите домен (напр.: example.com)",
    
    // Game Page Additional
    WebStringKey.Safe to "Безопасно",
    WebStringKey.TimeAgo to "назад",
    WebStringKey.MinutesAgo to "мин назад",
    WebStringKey.HoursAgo to "ч назад",
    
    // Misc
    WebStringKey.Critical to "КРИТИЧНО",
    WebStringKey.Warn to "ВНИМАНИЕ",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "Чувствительность обнаружения фишинга",
    WebStringKey.SensitivityDescription to "Настройте эвристические пороги. Более высокая чувствительность может увеличить ложные срабатывания.",
    WebStringKey.SensitivityLow to "Низкая",
    WebStringKey.SensitivityBalanced to "Сбалансированная",
    WebStringKey.SensitivityParanoia to "Паранойя",
    WebStringKey.BalancedModeRecommended to "Сбалансированный режим (Рекомендуется)",
    WebStringKey.BalancedModeDesc to "Ищет известные вредоносные паттерны и эвристические несоответствия. Блокирует атаки омографов и цепочки перенаправлений.",
    WebStringKey.LowSensitivityMode to "Режим низкой чувствительности",
    WebStringKey.LowSensitivityModeDesc to "Блокирует только известные вредоносные URL из базы угроз. Минимум ложных срабатываний, но может пропустить новые атаки.",
    WebStringKey.ParanoiaMode to "Режим паранойи",
    WebStringKey.ParanoiaModeDesc to "Максимальная защита. Блокирует любые подозрительные шаблоны, включая недавно зарегистрированные домены, необычные TLD и любые URL с потенциальными трюками кодирования.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard использует локальные эвристические аналитические движки. Никакие данные изображений, строки URL или метаданные не покидают это устройство во время сканирования. Ваша конфиденциальность математически гарантирована.",
    WebStringKey.SignalBrandImpersonation to "Обнаружена потенциальная имитация бренда",
    WebStringKey.SignalCredentialParams to "Параметры, связанные с учетными данными в URL",
    WebStringKey.SignalEncodedPayload to "Обнаружены закодированные данные в параметрах запроса",
    WebStringKey.SignalExcessiveSubdomains to "Чрезмерная глубина поддоменов ({count} уровней)",
    WebStringKey.SignalHighEntropyHost to "Высокая случайность в имени домена",
    WebStringKey.SignalHomographAttack to "Домен содержит омографы/путаемые символы",
    WebStringKey.SignalHttpNotHttps to "Использует небезопасный протокол HTTP",
    WebStringKey.SignalIpAddressHost to "Хост - IP-адрес вместо домена",
    WebStringKey.SignalLongUrl to "Необычно длинный URL ({length} символов)",
    WebStringKey.SignalLongUrlMarketing to "Необычно длинный URL ({length} символов) - содержит маркетинговые параметры",
    WebStringKey.SignalNewlyRegisteredDomain to "Обнаружен недавно зарегистрированный домен",
    WebStringKey.SignalNonStandardPort to "Нестандартный порт: {port}",
    WebStringKey.SignalNumericSubdomain to "Обнаружен числовой поддомен",
    WebStringKey.SignalSuspiciousPathKeywords to "Подозрительные ключевые слова в пути ({count} найдено)",
    WebStringKey.SignalSuspiciousTld to "Подозрительный TLD: {tld}",
    WebStringKey.SignalUrlShortener to "Использует сервис сокращения URL",
    WebStringKey.SecureEnvironment to "Безопасная среда",
    WebStringKey.LearnLocalArchitecture to "Узнайте о нашей локальной архитектуре",
    WebStringKey.NoCustomDomainsBlocked to "Нет заблокированных пользовательских доменов.",
    WebStringKey.AddManually to "Добавить вручную",
    WebStringKey.AddedDaysAgo to "Добавлено 2 дня назад",
    WebStringKey.AddedWeekAgo to "Добавлено 1 неделю назад",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "Управление конфиденциальностью",
    WebStringKey.StrictOfflineMode to "Строгий офлайн-режим",
    WebStringKey.DisableExternalPreviews to "Отключить все предпросмотры внешних ссылок.",
    WebStringKey.AnonymousTelemetry to "Анонимная телеметрия",
    WebStringKey.ShareDetectionStats to "Делиться статистикой обнаружения для улучшения ML.",
    WebStringKey.AutoCopySafeLinks to "Авто-копирование безопасных ссылок",
    WebStringKey.CopyTrustedUrls to "Копировать доверенные URL в буфер обмена.",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "О Mehr Guard",
    WebStringKey.OpenSourceLicenses to "Лицензии открытого ПО",
    WebStringKey.PrivacyPolicy to "Политика конфиденциальности",
    WebStringKey.Acknowledgements to "Благодарности",
    WebStringKey.ResetAllSettings to "Сбросить все настройки",
    WebStringKey.AddToAllowlist to "Добавить в список разрешённых",
    WebStringKey.AddToBlocklist to "Добавить в список заблокированных",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "Проанализировано офлайн.",
    WebStringKey.YourDataStaysOnDevice to "Ваши данные остаются на устройстве.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard обрабатывает каждое сканирование с безопасным анализом на устройстве. Мы отдаём приоритет объяснимой безопасности без облачной телеметрии.",
    WebStringKey.OnDeviceAnalysis to "Анализ на устройстве",
    WebStringKey.OnDeviceAnalysisDesc to "Всё обнаружение угроз выполняется локально на вашем устройстве. Никакие данные не покидают вашу систему.",
    WebStringKey.NoCloudLogs to "Нет облачных логов",
    WebStringKey.NoCloudLogsDesc to "Мы строго отключаем исходящую телеметрию для сканирований. Результаты и хеши остаются локальными.",
    WebStringKey.OnDeviceDB to "База данных на устройстве",
    WebStringKey.OnDeviceDBDesc to "Полная база сигнатур угроз загружается на ваше устройство для поиска за миллисекунды.",
    WebStringKey.DataLifecycleVerification to "Проверка жизненного цикла данных",
    WebStringKey.SecurityAuditPass to "Аудит безопасности: ПРОЙДЕН",
    
    // Footer
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc. Все права защищены.",
    WebStringKey.Support to "Поддержка",
    WebStringKey.Terms to "Условия",
    WebStringKey.SystemsOperational to "Системы работают",
    WebStringKey.SystemSecure to "Система защищена",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • Система защищена",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "Проверено Mehr Guard Enterprise",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "Иван Петров",
    WebStringKey.SampleUserRole to "Аналитик безопасности",
    
    // Export Preview
    WebStringKey.DetailLabel to "Метка детали",
    WebStringKey.DetailValue to "Значение детали",
    WebStringKey.Suspicious to "Подозрительно",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "Неверное решение",
    WebStringKey.WrongAnswer to "Упс! Это было неправильно.",
    WebStringKey.ResponseTime to "Время ответа",
    WebStringKey.IncomingMessage to "Входящее сообщение",
    WebStringKey.CertificateIssuer to "Издатель сертификата соответствует владельцу домена",
    WebStringKey.DomainAgeTrust to "Возраст домена > 5 лет (Высокое доверие)",
    WebStringKey.WhitelistedRank to "Топ 1k Alexa в локальном белом списке",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "Образовательная заметка",
    WebStringKey.GameHintTitle to "Подсказка игры",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "Добавить в список разрешённых",
    WebStringKey.AddToBlocklistTitle to "Добавить в список заблокированных",
    WebStringKey.EnterDomainPrompt to "Введите домен для добавления в ваш список",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "Задержка",
    WebStringKey.StreakFire to "Серия",
    WebStringKey.AccuracyPercent to "Точность",
    WebStringKey.ConfidencePercent to "Уверенность",
    
    // Languages
    WebStringKey.English to "Английский",
    WebStringKey.German to "Немецкий",
    WebStringKey.Spanish to "Испанский",
    WebStringKey.French to "Французский",
    WebStringKey.ChineseSimplified to "Китайский (Упрощённый)",
    WebStringKey.Japanese to "Японский",
    WebStringKey.Hindi to "Хинди",
    WebStringKey.Arabic to "Арабский",
    WebStringKey.Indonesian to "Индонезийский",
    WebStringKey.Italian to "Итальянский",
    WebStringKey.Korean to "Корейский",
    WebStringKey.Portuguese to "Португальский",
    WebStringKey.Russian to "Русский",
    WebStringKey.Thai to "Тайский",
    WebStringKey.Turkish to "Турецкий",
    WebStringKey.Vietnamese to "Вьетнамский"
,
    WebStringKey.ComponentVoting to "Голосование компонентов",
    WebStringKey.Heuristic to "Эвристика",
    WebStringKey.MLModel to "ML модель",
    WebStringKey.Brand to "Бренд",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "Большинство голосов определяет вердикт: 3+ БЕЗОПАСНО = зелёный, 2+ ВРЕДОНОСНО = красный"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "Ожидание сканирования...",
    WebStringKey.WaitingForAnalysis to "Ожидание анализа...",
    WebStringKey.ScanURLToSeeResults to "Отсканируйте URL для просмотра подробных результатов.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Горячие клавиши",
    WebStringKey.StartScanner to "Запустить сканер",
    WebStringKey.CloseMenuModal to "Закрыть меню / окно",
    WebStringKey.NavigateToDashboard to "Перейти на панель",
    WebStringKey.NavigateToHistory to "История сканирования",
    WebStringKey.NavigateToTrust to "Центр доверия / Белый список",
    WebStringKey.NavigateToGame to "Игра Победи бота",
    WebStringKey.ShowHelp to "Показать справку",
    WebStringKey.GotIt to "Понятно",
    WebStringKey.SecuritySettings to "Настройки безопасности",
    WebStringKey.SensitivityLevel to "Уровень чувствительности",
    WebStringKey.AutoBlockThreats to "Автоблокировка угроз",
    WebStringKey.RealTimeScanning to "Сканирование в реальном времени",
    WebStringKey.SoundAlerts to "Звуковые оповещения",
    WebStringKey.ThreatAlerts to "Оповещения об угрозах",
    WebStringKey.ShowConfidenceScore to "Показать оценку достоверности",
    WebStringKey.CompactView to "Компактный вид",
    WebStringKey.ResetDefaults to "Сбросить настройки",
    WebStringKey.SaveAndContinue to "Сохранить и продолжить",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "ПОДОЗРИТЕЛЬНАЯ АКТИВНОСТЬ",
    WebStringKey.VerdictWarning to "Предупреждение",
    WebStringKey.VerdictSuspiciousDesc to "Отсканированный QR-код показывает подозрительные паттерны, которые могут указывать на потенциальные риски безопасности. Продолжайте с осторожностью.",
    WebStringKey.VerdictMinorConcerns to "НЕЗНАЧИТЕЛЬНЫЕ ОПАСЕНИЯ",
    WebStringKey.VerdictCaution to "Осторожно",
    WebStringKey.VerdictMinorConcernsDesc to "Обнаружены незначительные проблемы безопасности. Ссылка выглядит в основном безопасно, но рекомендуется проверка.",
    WebStringKey.VerdictVerifiedSafe to "ПРОВЕРЕНО БЕЗОПАСНО",
    WebStringKey.VerdictSafeLabel to "Безопасно",
    WebStringKey.VerdictVerifiedSafeDesc to "Угрозы безопасности не обнаружены. QR-код ведёт к проверенному безопасному назначению.",
    WebStringKey.VerdictNoActivity to "Нет активности",
    WebStringKey.VerdictAwaitingScan to "Ожидание сканирования",
    WebStringKey.VerdictNoActivityDesc to "Данные сканирования недоступны. Отсканируйте QR-код или введите URL для анализа.",
    WebStringKey.ScanQrToSeeActivity to "Отсканируйте QR-код, чтобы увидеть вашу активность здесь",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Точка данных",
    WebStringKey.ProcessingEnv to "Среда обработки",
    WebStringKey.ExternalTransmission to "Внешняя передача",
    WebStringKey.RawImageBuffer to "Буфер сырого изображения",
    WebStringKey.LocalMemoryRam to "Локальная память (RAM)",
    WebStringKey.TransmissionNone to "Нет",
    WebStringKey.DecodedUrlPayload to "Декодированный URL/Полезная нагрузка",
    WebStringKey.LocalAnalysis to "Локальный анализ",
    WebStringKey.ThreatVerdictLabel to "Вердикт угрозы",
    WebStringKey.LocalDatabase to "Локальная база данных",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "О Mehr Guard Security",
    WebStringKey.ActualDomain to "Фактический домен",
    WebStringKey.AnalysisComplete to "Анализ завершён",
    WebStringKey.AutoBlockThreatsDesc to "Автоматически блокировать угрозы",
    WebStringKey.AwaitingScanLabel to "Ожидание сканирования",
    WebStringKey.BrandImpersonation to "Подделка бренда",
    WebStringKey.CautionAdvised to "Рекомендуется осторожность",
    WebStringKey.CompactViewDesc to "Компактный вид",
    WebStringKey.DoNotVisit to "НЕ ПОСЕЩАЙТЕ",
    WebStringKey.DoNotVisitDesc to "Обнаружен фишинг с высокой достоверностью. Этот URL показывает множественные вредоносные индикаторы.",
    WebStringKey.DomainUsesInternationalChars to "Этот домен использует международные символы, которые могут имитировать легитимные домены.",
    WebStringKey.GoToScanner to "Перейти к сканеру",
    WebStringKey.Hebrew to "Иврит",
    WebStringKey.HelpKeyboardShortcuts to "Горячие клавиши",
    WebStringKey.HeuristicAnalysis to "Эвристический анализ",
    WebStringKey.HeuristicAnalysisDesc to "URL отмечен на основе нескольких факторов риска, обнаруженных аналитическим движком.",
    WebStringKey.HiddenDestination to "Скрытое назначение",
    WebStringKey.HighRisk to "Высокий риск",
    WebStringKey.HighRiskLabel to "ВЫСОКИЙ РИСК",
    WebStringKey.HomographIdnAttack to "Атака омографа / IDN",
    WebStringKey.InternationalizedDomainDetected to "Обнаружено интернационализированное доменное имя.",
    WebStringKey.JustNow to "Только что",
    WebStringKey.KeyboardShortcutsDesc to "Горячие клавиши для быстрого доступа",
    WebStringKey.LiveFeedActive to "ПРЯМАЯ ТРАНСЛЯЦИЯ АКТИВНА",
    WebStringKey.LowRisk to "Низкий риск",
    WebStringKey.LowRiskLabel to "НИЗКИЙ РИСК",
    WebStringKey.Malicious to "Вредоносный",
    WebStringKey.MediumRiskLabel to "СРЕДНИЙ РИСК",
    WebStringKey.NoData to "НЕТ ДАННЫХ",
    WebStringKey.NoScanDataResults to "Нет данных сканирования. Пожалуйста, отсканируйте URL для просмотра результатов анализа.",
    WebStringKey.NoUrlScanned to "URL не отсканирован",
    WebStringKey.Persian to "Персидский",
    WebStringKey.PhishingIndicators to "Индикаторы фишинга",
    WebStringKey.ProceedWithCaution to "ДЕЙСТВУЙТЕ С ОСТОРОЖНОСТЬЮ",
    WebStringKey.ProceedWithCautionDesc to "Обнаружены некоторые подозрительные индикаторы. Проверьте источник перед вводом конфиденциальной информации.",
    WebStringKey.RealTimeScanningDesc to "Сканирование в реальном времени",
    WebStringKey.RedirectShortenerDetected to "Обнаружен редирект/сокращатель",
    WebStringKey.SafeToVisit to "БЕЗОПАСНО ДЛЯ ПОСЕЩЕНИЯ",
    WebStringKey.SafeToVisitDesc to "Проверено локальной эвристикой v2.4. Паттерны фишинга, обфусцированные скрипты или совпадения в чёрном списке не обнаружены.",
    WebStringKey.SafetyScore to "Оценка безопасности",
    WebStringKey.ScanCompleteLabel to "Сканирование завершено",
    WebStringKey.ScanToAnalyze to "Отсканируйте QR-код или введите URL для анализа.",
    WebStringKey.ScannedURLLabel to "Отсканированный URL",
    WebStringKey.SecuritySignal to "Сигнал безопасности",
    WebStringKey.SensitivityLevelDesc to "Уровень чувствительности",
    WebStringKey.SensitivityPermissive to "Разрешительный",
    WebStringKey.SensitivityStrict to "Строгий",
    WebStringKey.SettingsDetection to "Обнаружение",
    WebStringKey.SettingsDisplay to "Отображение",
    WebStringKey.SettingsLanguage to "Язык",
    WebStringKey.SettingsLanguageDesc to "Выберите язык интерфейса",
    WebStringKey.SettingsNotifications to "Уведомления",
    WebStringKey.SettingsSavedAutomatically to "Настройки сохраняются автоматически и синхронизируются между сессиями.",
    WebStringKey.ShowConfidenceScoreDesc to "Показать оценку достоверности",
    WebStringKey.SoundAlertsDesc to "Звуковые оповещения",
    WebStringKey.SuspiciousDomain to "Подозрительный домен",
    WebStringKey.SuspiciousEncoding to "Подозрительная кодировка",
    WebStringKey.SuspiciousKeywords to "Подозрительные ключевые слова",
    WebStringKey.SuspiciousTld to "Подозрительный TLD",
    WebStringKey.SuspiciousTldDesc to "Домен использует {tld} TLD, обычно связанный с вредоносными сайтами.",
    WebStringKey.SuspiciousUrlParams to "Подозрительные параметры URL",
    WebStringKey.SuspiciousUrlParamsDesc to "URL содержит сложные или потенциально обфусцированные параметры.",
    WebStringKey.ThreatAlertsDesc to "Оповещения об угрозах",
    WebStringKey.ThreatDetected to "Обнаружена угроза",
    WebStringKey.UnableToDetermine to "Не удалось определить вердикт. Пожалуйста, попробуйте снова.",
    WebStringKey.Unknown to "Неизвестно",
    WebStringKey.UnknownURL to "Неизвестный URL",
    WebStringKey.UrlShortenerDesc to "URL использует сервис сокращения, скрывающий конечное назначение.",
    WebStringKey.UrlShortenerDetected to "Обнаружен сокращатель URL",
    WebStringKey.VersionOfflineReady to "Готов к работе офлайн",
    WebStringKey.VisualAppearance to "Визуальное отображение",
    WebStringKey.WaitingForAnalysisLabel to "Ожидание анализа...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "JavaScript URL",
    WebStringKey.ReasonJavascriptUrlDesc to "Обнаружена схема JavaScript URL - выполняет код при клике",
    WebStringKey.ReasonDataUriTitle to "Data URI",
    WebStringKey.ReasonDataUriDesc to "Обнаружена схема Data URI - может содержать встроенный вредоносный код",
    WebStringKey.ReasonAtSymbolInjectionTitle to "Внедрение символа @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL содержит символ @, указывающий на возможную попытку кражи учётных данных",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Омографическая атака",
    WebStringKey.ReasonHomographDesc to "Интернационализированное доменное имя (IDN) может имитировать другой домен",
    WebStringKey.ReasonMixedScriptTitle to "Смешанный скрипт",
    WebStringKey.ReasonMixedScriptDesc to "Имя хоста содержит символы из разных скриптов (возможный спуфинг)",
    WebStringKey.ReasonLookalikeCharsTitle to "Похожие символы",
    WebStringKey.ReasonLookalikeCharsDesc to "Домен содержит Unicode-символы, похожие на ASCII-буквы",
    WebStringKey.ReasonZeroWidthCharsTitle to "Символы нулевой ширины",
    WebStringKey.ReasonZeroWidthCharsDesc to "Обнаружены скрытые Unicode-символы нулевой ширины (попытка обфускации)",
    WebStringKey.ReasonIpHostTitle to "IP-хост",
    WebStringKey.ReasonIpHostDesc to "URL использует IP-адрес вместо доменного имени",
    WebStringKey.ReasonCredentialParamTitle to "Параметр учётных данных",
    WebStringKey.ReasonCredentialParamDesc to "URL содержит параметры, связанные с учётными данными (пароль, токен и т.д.)",
    WebStringKey.ReasonBrandImpersonationTitle to "Имитация бренда",
    WebStringKey.ReasonBrandImpersonationDesc to "URL, по-видимому, имитирует известный бренд",
    WebStringKey.ReasonBrandInSubdomainTitle to "Бренд в поддомене",
    WebStringKey.ReasonBrandInSubdomainDesc to "Название бренда присутствует в поддомене, но не в основном домене",
    WebStringKey.ReasonRiskyExtensionTitle to "Опасное расширение",
    WebStringKey.ReasonRiskyExtensionDesc to "Путь содержит потенциально опасное расширение файла",
    WebStringKey.ReasonDoubleExtensionTitle to "Двойное расширение",
    WebStringKey.ReasonDoubleExtensionDesc to "Обнаружено двойное расширение файла (распространённая тактика вредоносного ПО)",
    WebStringKey.ReasonEncodedPayloadTitle to "Закодированная нагрузка",
    WebStringKey.ReasonEncodedPayloadDesc to "Обнаружены большие закодированные данные в параметрах URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP вместо HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL использует небезопасный протокол HTTP вместо HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "Подозрительный TLD",
    WebStringKey.ReasonSuspiciousTldDesc to "Домен верхнего уровня часто используется для фишинга",
    WebStringKey.ReasonHighEntropyHostTitle to "Хост с высокой энтропией",
    WebStringKey.ReasonHighEntropyHostDesc to "Доменное имя выглядит сгенерированным случайно",
    WebStringKey.ReasonRedirectParamTitle to "Параметр перенаправления",
    WebStringKey.ReasonRedirectParamDesc to "URL содержит параметр перенаправления, который может вести на другой сайт",
    WebStringKey.ReasonDeepSubdomainTitle to "Глубокий поддомен",
    WebStringKey.ReasonDeepSubdomainDesc to "Избыточная глубина поддоменов (может скрывать реальный домен)",
    WebStringKey.ReasonMultiTldTitle to "Множественный TLD",
    WebStringKey.ReasonMultiTldDesc to "Несколько сегментов, похожих на TLD, в имени домена",
    WebStringKey.ReasonNumericSubdomainTitle to "Числовой поддомен",
    WebStringKey.ReasonNumericSubdomainDesc to "Обнаружен полностью числовой поддомен",
    WebStringKey.ReasonNonStandardPortTitle to "Нестандартный порт",
    WebStringKey.ReasonNonStandardPortDesc to "URL использует нестандартный номер порта",
    WebStringKey.ReasonSuspiciousPortTitle to "Подозрительный порт",
    WebStringKey.ReasonSuspiciousPortDesc to "URL использует порт, обычно связанный с атаками",
    WebStringKey.ReasonFragmentHidingTitle to "Скрытие во фрагменте",
    WebStringKey.ReasonFragmentHidingDesc to "Фрагмент URL, по-видимому, скрывает дополнительный контент",
    WebStringKey.ReasonExcessiveEncodingTitle to "Избыточное кодирование",
    WebStringKey.ReasonExcessiveEncodingDesc to "Обнаружено избыточное кодирование URL (попытка обфускации)",
    WebStringKey.ReasonDomainAgePatternTitle to "Паттерн возраста домена",
    WebStringKey.ReasonDomainAgePatternDesc to "Доменное имя соответствует паттернам автоматически сгенерированных доменов",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "Сокращатель URL",
    WebStringKey.ReasonUrlShortenerDesc to "URL использует сервис сокращения (скрывает реальное назначение)",
    WebStringKey.ReasonSuspiciousPathTitle to "Подозрительный путь",
    WebStringKey.ReasonSuspiciousPathDesc to "Путь содержит подозрительные ключевые слова (login, verify и т.д.)",
    WebStringKey.ReasonLongUrlTitle to "Длинный URL",
    WebStringKey.ReasonLongUrlDesc to "Необычно длинный URL",
    WebStringKey.ReasonCredentialKeywordsTitle to "Ключевые слова учётных данных",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL содержит ключевые слова для сбора учётных данных",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "Нераспознаваемый URL",
    WebStringKey.ReasonUnparseableDesc to "URL не удалось полностью распознать",
    WebStringKey.ReasonAnalysisCompleteTitle to "Анализ завершён",
    WebStringKey.ReasonAnalysisCompleteDesc to "Анализ успешно завершён",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "ML-оценка фишинга",
    WebStringKey.MlCharacterAnalysis to "Анализ символов",
    WebStringKey.MlFeatureAnalysis to "Анализ признаков",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "IDN / Punycode домен",
    WebStringKey.IdnPunycodeDomainDesc to "Этот домен использует интернационализированные символы. Безопасное отображение:",
    WebStringKey.MixedScriptAttackTitle to "Атака смешанных скриптов",
    WebStringKey.MixedScriptAttackDesc to "Домен содержит символы из нескольких письменностей (например, кириллица + латиница). Часто используется в атаках-омографах.",
    WebStringKey.ConfusableCharsTitle to "Похожие символы",
    WebStringKey.ConfusableCharsDesc to "Домен содержит символы, похожие на обычные буквы (например, 'а' vs 'a')."
)

internal val RussianCommonStrings = mapOf(
    "Engine Active" to "Движок активен",
    "Enterprise Protection Active" to "Корпоративная защита активна",
    "Start New Scan" to "Начать новое сканирование",
    "Import Image" to "Импорт изображения",
    "System Health" to "Состояние системы",
    "Threat Database" to "База данных угроз",
    "Current" to "Текущий",
    "Heuristic Engine" to "Эвристический движок",
    "Active" to "Активен",
    "Threats" to "Угрозы",
    "Safe Scans" to "Безопасные сканирования",
    "Recent Scans" to "Недавние сканирования",
    "View Full History" to "Просмотреть полную историю",
    "Status" to "Статус",
    "Source" to "Источник",
    "Details" to "Детали",
    "Time" to "Время",
    "SAFE" to "БЕЗОПАСНО",
    "SUSPICIOUS" to "ПОДОЗРИТЕЛЬНО",
    "PHISHING" to "ФИШИНГ",
    "UNKNOWN" to "НЕИЗВЕСТНО",
    "Version" to "Версия",
    "Last Update" to "Последнее обновление",
    "Signatures" to "Сигнатуры",
    "Check for Updates" to "Проверить обновления",
    "Active Scanner" to "Активный сканер",
    "Offline Mode" to "Офлайн-режим",
    "Camera Access Required" to "Требуется доступ к камере",
    "Enable Camera" to "Включить камеру",
    "Scanning..." to "Сканирование...",
    "Torch" to "Фонарик",
    "Gallery" to "Галерея",
    "Paste URL" to "Вставить URL",
    "Analyze URL" to "Анализировать URL",
    "Analyze" to "Анализировать",
    "READY" to "ГОТОВ",
    "Local DB" to "Локальная БД",
    "Latency" to "Задержка",
    "View All" to "Просмотреть все",
    "Dashboard" to "Панель",
    "Settings" to "Настройки",
    "Training Centre" to "Учебный центр",
    "Beat the Bot" to "Победи бота",
    "Safe" to "Безопасно",
    "Suspicious" to "Подозрительно",
    "Dangerous" to "Опасно",
    "Phishing" to "Фишинг",
    "Legitimate" to "Легитимный",
    "Block & Report" to "Заблокировать и сообщить",
    "Copy Link" to "Копировать ссылку",
    "Share" to "Поделиться",
    "Export Report" to "Экспорт отчёта",
    "Clear All" to "Очистить всё",
    "Cancel" to "Отмена",
    "Close" to "Закрыть",
    "Back to Dashboard" to "Вернуться к панели",
    "Scan Complete" to "Сканирование завершено",
    "High Risk" to "Высокий риск",
    "Low Risk" to "Низкий риск",
    "Risk Score" to "Оценка риска",
    "Confidence" to "Уверенность",
    "Homograph Attack" to "Атака омографов",
    "Detected" to "Обнаружено",
    "Русский" to "Русский"
)
